export enum QueueActionType {
	CALL = "CALL",
	CANCEL = "CANCEL",
	NO_SHOW = "NO_SHOW",
	CONFIRM = "CONFIRM"
}



// WEBPACK FOOTER //
// ./src/app/pages/queue/enums/queue-action-type.enum.ts